module.exports = __webpack_public_path__ + "img/display-2-select.3d74341c.svg";